import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminUserDetail = lazy(() => import("@/pages/admin/AdminUserDetail"));

export const Route = createFileRoute("/admin/users/$userId")({
  component: AdminUserDetail,
});
